import React from "react";
import { get } from "lodash";
import { PrimaryButton, ButtonSizeOptions, LabelPercentFormatted } from "@loanbossinc/component-library";
import styled from "styled-components";

const StyledLabelPercentFormatted = styled(LabelPercentFormatted)`&&{
    float: left;
  }`;

export const shouldShowCompanyName = guarantor => guarantor.guarantorType === "company";

export const shouldShowIndividualName = guarantor => guarantor.guarantorType === "individual";

export const hasRecourseSchedule = guarantor => guarantor && guarantor.hasRecourseSchedule;

export const isNew = guarantor => !guarantor || (guarantor && !guarantor.id);

export const shouldSendNotification = guarantor => guarantor && guarantor.shouldSendNotification;

export const shouldShowSendNotificationList = guarantor => guarantor && guarantor.shouldSendNotification;

export const disableRecourseScheduleAdd = (data, type, index) => {
  const guarantors = get(data, type);
  const guarantor = guarantors[index];
  const schedules = guarantor.guarantorRecourseSchedules;
  for (let index = 0; index < schedules.length; index++) {
    const schedule = schedules[index];
    if (!isScheduleValid(schedule)) {
      return true;
    }
  }

  return false;
};

const isScheduleValid = schedule => (
  Boolean(schedule.recourseAmount) ||
            Boolean(schedule.recoursePercent)
) &&
           (
             Boolean(schedule.dscr) ||
                Boolean(schedule.ltv) ||
                Boolean(schedule.debtYield) ||
                Boolean(schedule.occupancy) ||
                schedule.guarantorRecourseScheduleCustomConditions.length > 0
           );

const markComplete = (loan, customConditon, startSave) => {
  customConditon.isComplete = !customConditon.isComplete;
  startSave(loan);
};

export const generateDetailsConfig = (loan, index, schedulesIndex, startSave) => {
  const config = [
    { label: "Debt Yield", path: "debtYield", style: {}, formatting: value => (<StyledLabelPercentFormatted value={value / 100} lines={1} />) },
    { label: "Occupancy", path: "occupancy", style: {}, formatting: value => (<StyledLabelPercentFormatted value={value / 100} lines={1} />) }
  ];

  const hasCustomConditon = loan &&
                              loan.personalGuarantors[index] &&
                              loan.personalGuarantors[index].guarantorRecourseSchedules &&
                              loan.personalGuarantors[index].guarantorRecourseSchedules[schedulesIndex] &&
                              loan.personalGuarantors[index].guarantorRecourseSchedules[schedulesIndex].guarantorRecourseScheduleCustomConditions &&
                              loan.personalGuarantors[index].guarantorRecourseSchedules[schedulesIndex].guarantorRecourseScheduleCustomConditions.length > 0;
  if (hasCustomConditon) {
    for (let i = 0; i < loan.personalGuarantors[index].guarantorRecourseSchedules[schedulesIndex].guarantorRecourseScheduleCustomConditions.length; i++) {
      const path = `guarantorRecourseScheduleCustomConditions[${i}].condition`;
      const customConditon = loan.personalGuarantors[index].guarantorRecourseSchedules[schedulesIndex].guarantorRecourseScheduleCustomConditions[i];
      const condition = customConditon.condition;
      const isComplete = customConditon.isComplete;
      config.push({
        label: `${condition}`,
        path,
        style: {},
        formatting: value => (<>{`${isComplete ? "Complete" : "Incomplete"}`}</>),
        action: value => (<PrimaryButton
          style={{ float: "right" }}
          label={`Mark as ${isComplete ? "incomplete" : "complete"}`}
          onClick={() => markComplete(loan, customConditon, startSave)}
          size={ButtonSizeOptions.smFluid}
        />)
      });
    }
  }

  return config;
};
